import axios from '@axios'

export default {
  namespaced: true,
  state: {
    ability: {
      id: null,
      action: null,
      subject: null,
      description: null,
    },
    abilities: [],
    totalAbilities: 0,
  },
  getters: {
    GET_ABILITY: state => state.ability,
    GET_ABILITIES: state => state.ability,
  },
  mutations: {
    SET_ABILITIES(state, payload) {
      state.abilities = payload
    },
    SET_ABILITY(state, payload) {
      state.ability = payload
    },
    SET_TOTAL_ABILITIES(state, payload) {
      state.totalAbilities = payload
    },
  },
  actions: {
    findAll(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('/ability', { params: queryParams })
          .then(response => {
            ctx.commit('SET_ABILITIES', response.data.abilities)
            ctx.commit('SET_TOTAL_ABILITIES', response.data.total)
            resolve(response)
          })
          .catch(error => reject(error))
      })
    },
    findById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/ability/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    create(ctx, dataCreate) {
      return new Promise((resolve, reject) => {
        axios
          .post('/ability', dataCreate)
          .then(response => resolve(response))
          .catch(error => {
            reject(error)
          })
      })
    },
    update(ctx, dataUpdate) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/ability/${dataUpdate.id}`, {
            ...dataUpdate,
          })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    delete(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/ability/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
